const ACTIVE_CLASS = 'is-active';
const OPEN_CLASS = 'is-open';

const toggleButton = document.getElementById('index-nav-button');
const closeButton = document.querySelectorAll('.js-index-nav-close-button');
const nav = document.getElementById('index-nav');
const closeLayer = document.getElementById('index-nav-close-layer');
// const anchors = nav.querySelectorAll('a[href^="#"]');

const openMenu = () => {
  toggleButton.classList.add(ACTIVE_CLASS);
  nav.classList.add(OPEN_CLASS);
  closeLayer.style.opacity = 1;
  closeLayer.style.visibility = 'visible';
};

const closeMenu = () => {
  toggleButton.classList.remove(ACTIVE_CLASS);
  nav.classList.remove(OPEN_CLASS);
  closeLayer.style.opacity = 0;
  closeLayer.style.visibility = 'hidden';
};

const toggleMenu = () => {
  if (toggleButton.classList.contains(ACTIVE_CLASS)) {
    closeMenu();
  } else {
    openMenu();
  }
};

const init = () => {
  if (!toggleButton || !closeButton || !nav) {
    return;
  }

  toggleButton.addEventListener('click', toggleMenu);

  closeButton.forEach(button => {
    button.addEventListener('click', closeMenu);
  });

  // anchors.forEach(anchor => {
  //   anchor.addEventListener('click', closeMenu);
  // });
};

export default init;
